import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import TableCustomKeysNoPagination from '@src/Pages/Private/Cliente/Admin/CorrespondenciaDevolvida/TableCustomKeysNoPagination';
import { TitlePage } from '@src/@styles/styles.global';

import InvisibleContent from '@src/components/Shared/InvisibleContent';

import NaoAprovados from '@src/Pages/Private/shared/SolicitacaoAtendimento/ListAtendidos/ProgramaTv/NaoAprovados';
import Aprovados from '@src/Pages/Private/shared/SolicitacaoAtendimento/ListAtendidos/ProgramaTv/Aprovados';


const SolicitacaoAtendimento: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState('');

  const [openAprovados, setOpenAprovados] = useState(false);
  const [openNaoAprovados, setOpenNaoAprovados] = useState(false);

  useEffect(() => {
    window.document.title = 'CRM - Solicitações atendimento';
  }, []);

  return (
    <Grid container>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            //onClick={() => setOpenModalAddCorrespondencia(true)}
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Intencao' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencao'), setOpenAprovados(false), setOpenNaoAprovados(true))}
          >
            Lista a serem aprovados
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Intencao missa' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencao missa'), setOpenNaoAprovados(false), setOpenAprovados(true))}
          >
            Lista de aprovados
          </ButtonComponent>
        </Grid>


        <InvisibleContent visible={openAprovados === true}>


          <Aprovados />
        </InvisibleContent>

        <InvisibleContent visible={openNaoAprovados === true}>
        <NaoAprovados />
        </InvisibleContent>


      </Grid>

    </Grid>
  );
};

export default SolicitacaoAtendimento;
